import { render, staticRenderFns } from "./FooterSocialNewsletter.vue?vue&type=template&id=39563275&"
import script from "./FooterSocialNewsletter.vue?vue&type=script&lang=js&"
export * from "./FooterSocialNewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports